import { render, staticRenderFns } from "./Plug.vue?vue&type=template&id=4c35ff9c&scoped=true&"
import script from "./Plug.vue?vue&type=script&lang=js&"
export * from "./Plug.vue?vue&type=script&lang=js&"
import style0 from "./Plug.vue?vue&type=style&index=0&id=4c35ff9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c35ff9c",
  null
  
)

export default component.exports